import { AddRegistrationModal, EditRegistrationModal, FeedbackEditModal, GuideEditModal, TestimonialEditModal } from "./AdminModals";

export const AdminModalsHost = ({ reg, fb, tm, gd }) => (
  <>
    <EditRegistrationModal
      editing={reg.editing}
      onClose={() => reg.setEditing(null)}
      editForm={reg.editForm}
      setEditForm={reg.setEditForm}
      saveEdit={reg.saveEdit}
      saving={reg.saving}
    />
    <TestimonialEditModal
      editingT={tm.editingT}
      onClose={() => tm.setEditingT(null)}
      tEditForm={tm.tEditForm}
      setTEditForm={tm.setTEditForm}
      tEditImages={tm.tEditImages}
      setTEditImages={tm.setTEditImages}
      tEditDragIdx={tm.tEditDragIdx}
      setTEditDragIdx={tm.setTEditDragIdx}
      moveTEditImage={tm.moveTEditImage}
      addEditPhotos={tm.addEditPhotos}
      tEditUploading={tm.tEditUploading}
      saveEditT={tm.saveEditT}
    />
    <FeedbackEditModal
      editingFb={fb.editingFb}
      onClose={() => fb.setEditingFb(null)}
      fbEditForm={fb.fbEditForm}
      setFbEditForm={fb.setFbEditForm}
      saveEditFb={fb.saveEditFb}
    />
    <GuideEditModal
      editingG={gd.editingG}
      onClose={() => gd.setEditingG(null)}
      gEditForm={gd.gEditForm}
      setGEditForm={gd.setGEditForm}
      gEditFile={gd.gEditFile}
      setGEditFile={gd.setGEditFile}
      saveEditG={gd.saveEditG}
    />
    <AddRegistrationModal
      open={reg.addingReg}
      onClose={() => reg.setAddingReg(false)}
      regForm={reg.regForm}
      setRegForm={reg.setRegForm}
      createRegistration={reg.createRegistration}
      savingReg={reg.savingReg}
    />
  </>
);
